export default "__VITE_ASSET__u1u91RLp__"